/* SkinKlean video player (15 sep 2026)
   Mejora cualquier contenedor .skp que tenga un <video> dentro:
   barra con play/pausa, barra de progreso con arrastre, tiempo, sonido y pantalla completa.
   - El video puede venir sin src (data-sk-src / data-sk-hls): se carga al entrar en pantalla.
   - data-sk-autoplay: arranca en silencio al verse y se pausa al salir (salvo que el usuario lo pausara).
   - Tocar el video: si está en silencio, pone sonido; si ya suena, pausa/reanuda.
   - Solo un video con sonido a la vez.
   - La barra lleva swiper-no-swiping para que arrastrar el progreso no mueva el carrusel. */
(function () {
  if (window.SKPlayer) return;

  var ICON = {
    play: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5.5v13a1 1 0 0 0 1.5.86l10.5-6.5a1 1 0 0 0 0-1.72L9.5 4.64A1 1 0 0 0 8 5.5z" fill="currentColor"/></svg>',
    pause: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="6" y="5" width="4" height="14" rx="1.2" fill="currentColor"/><rect x="14" y="5" width="4" height="14" rx="1.2" fill="currentColor"/></svg>',
    muted: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 9h4l5-4v14l-5-4H4z" fill="currentColor"/><path d="M16.5 9.5l5 5m0-5l-5 5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
    sound: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 9h4l5-4v14l-5-4H4z" fill="currentColor"/><path d="M16 8.5a5 5 0 0 1 0 7M18.5 6a8.5 8.5 0 0 1 0 12" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round"/></svg>',
    fs: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 9V5a1 1 0 0 1 1-1h4M15 4h4a1 1 0 0 1 1 1v4M20 15v4a1 1 0 0 1-1 1h-4M9 20H5a1 1 0 0 1-1-1v-4" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round"/></svg>',
    fsExit: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 4v4a1 1 0 0 1-1 1H4M20 9h-4a1 1 0 0 1-1-1V4M15 20v-4a1 1 0 0 1 1-1h4M4 15h4a1 1 0 0 1 1 1v4" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round"/></svg>'
  };

  var CSS =
    '.skp{container-type:inline-size;}' +
    '.skp video{cursor:pointer;}' +
    '.skp-bar{position:absolute;left:0;right:0;bottom:0;z-index:4;display:flex;align-items:center;gap:6px;padding:28px 8px 8px;' +
      'background:linear-gradient(to top,rgba(0,0,0,.62),rgba(0,0,0,0));color:#fff;opacity:1;transition:opacity .25s ease;}' +
    '.skp.is-playing:not(.is-active) .skp-bar{opacity:0;}' +
    '@media (hover:none){.skp.is-playing:not(.is-active) .skp-bar{opacity:.92;}}' +
    '.skp-btn{flex:0 0 auto;width:32px;height:32px;padding:6px;margin:0;border:0;border-radius:50%;background:transparent;color:#fff;cursor:pointer;display:flex;align-items:center;justify-content:center;font:inherit;line-height:1;}' +
    '.skp-btn:hover{background:rgba(255,255,255,.16);}' +
    '.skp-btn:focus-visible,.skp-track:focus-visible{outline:2px solid #E2AD61;outline-offset:2px;}' +
    '.skp-btn svg{width:20px;height:20px;display:block;}' +
    '.skp-track{position:relative;flex:1 1 auto;height:24px;cursor:pointer;touch-action:none;display:flex;align-items:center;}' +
    '.skp-rail{position:absolute;left:0;right:0;height:4px;border-radius:4px;background:rgba(20,20,20,.45);box-shadow:0 0 0 1px rgba(255,255,255,.18);overflow:hidden;}' +
    '.skp-fill{position:absolute;left:0;top:0;bottom:0;width:0;background:#fff;}' +
    '.skp-knob{position:absolute;top:50%;left:0;width:12px;height:12px;margin:-6px 0 0 -6px;border-radius:50%;background:#fff;box-shadow:0 1px 3px rgba(0,0,0,.4);transform:scale(.0);transition:transform .15s ease;}' +
    '.skp-track:hover .skp-knob,.skp.is-seeking .skp-knob,.skp-track:focus-visible .skp-knob{transform:scale(1);}' +
    '@media (hover:none){.skp-knob{transform:scale(1);}}' +
    '.skp-time{flex:0 0 auto;min-width:34px;font-size:12px;line-height:1;font-variant-numeric:tabular-nums;text-align:right;color:#fff;}' +
    '.skp-big{position:absolute;left:50%;top:50%;z-index:3;width:56px;height:56px;margin:-28px 0 0 -28px;border:0;border-radius:50%;padding:14px;' +
      'background:rgba(20,20,20,.55);color:#fff;display:flex;align-items:center;justify-content:center;cursor:pointer;transition:opacity .2s ease;}' +
    '.skp-big svg{width:100%;height:100%;}' +
    '.skp.is-playing .skp-big{opacity:0;pointer-events:none;}' +
    '@container (max-width:280px){.skp-time{display:none;}.skp-btn{width:28px;height:28px;padding:5px;}.skp-bar{gap:2px;padding:22px 4px 4px;}}' +
    '.skp:fullscreen{padding-top:0 !important;width:100vw;height:100vh;border-radius:0 !important;background:#000 !important;}' +
    '.skp:-webkit-full-screen{padding-top:0 !important;width:100vw;height:100vh;border-radius:0 !important;background:#000 !important;}' +
    '.skp:fullscreen video{object-fit:contain !important;}' +
    '.skp:-webkit-full-screen video{object-fit:contain !important;}';

  function injectCss() {
    if (document.getElementById('skp-css')) return;
    var s = document.createElement('style');
    s.id = 'skp-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function fmt(t) {
    if (!isFinite(t) || t < 0) t = 0;
    var m = Math.floor(t / 60), s = Math.floor(t % 60);
    return m + ':' + (s < 10 ? '0' : '') + s;
  }

  function ensureSrc(v) {
    if (v.getAttribute('src') || v.querySelector('source')) return;
    var hls = v.dataset.skHls, mp4 = v.dataset.skSrc;
    var src = (hls && v.canPlayType('application/vnd.apple.mpegurl')) ? hls : mp4;
    if (src) v.src = src;
  }

  function play(v) {
    ensureSrc(v);
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }

  function fsElement() {
    return document.fullscreenElement || document.webkitFullscreenElement || null;
  }

  var observer = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var wrap = e.target, v = wrap.querySelector('video');
      if (!v) return;
      if (e.isIntersecting) {
        if (wrap.hasAttribute('data-sk-autoplay') && !wrap.dataset.skpUserPaused) play(v);
      } else if (!v.paused && fsElement() !== wrap) {
        v.pause();
        wrap.dataset.skpAutoPaused = '1';
      }
    });
  }, { rootMargin: '120px 0px', threshold: 0.35 }) : null;

  function muteOthers(current) {
    document.querySelectorAll('.skp video').forEach(function (o) {
      if (o !== current && !o.muted) { o.muted = true; o.dispatchEvent(new Event('volumechange')); }
    });
  }

  function enhance(wrap) {
    if (wrap.dataset.skpReady) return;
    var v = wrap.querySelector('video');
    if (!v) return;
    wrap.dataset.skpReady = '1';
    v.removeAttribute('controls');
    v.setAttribute('playsinline', '');
    if (wrap.hasAttribute('data-sk-autoplay')) v.muted = true;

    var bar = document.createElement('div');
    bar.className = 'skp-bar swiper-no-swiping';
    bar.innerHTML =
      '<button type="button" class="skp-btn skp-play" aria-label="Play">' + ICON.play + '</button>' +
      '<div class="skp-track" role="slider" tabindex="0" aria-label="Seek" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0">' +
        '<div class="skp-rail"><div class="skp-fill"></div></div><div class="skp-knob"></div></div>' +
      '<span class="skp-time">0:00</span>' +
      '<button type="button" class="skp-btn skp-mute" aria-label="Turn sound on">' + ICON.muted + '</button>' +
      '<button type="button" class="skp-btn skp-fs" aria-label="Full screen">' + ICON.fs + '</button>';
    wrap.appendChild(bar);

    var big = null;
    if (!wrap.hasAttribute('data-sk-autoplay')) {
      big = document.createElement('button');
      big.type = 'button';
      big.className = 'skp-big';
      big.setAttribute('aria-label', 'Play video');
      big.innerHTML = ICON.play;
      wrap.appendChild(big);
      big.addEventListener('click', function (e) { e.stopPropagation(); delete wrap.dataset.skpUserPaused; play(v); });
    }

    var bPlay = bar.querySelector('.skp-play'), bMute = bar.querySelector('.skp-mute'), bFs = bar.querySelector('.skp-fs');
    var track = bar.querySelector('.skp-track'), fill = bar.querySelector('.skp-fill'), knob = bar.querySelector('.skp-knob'), time = bar.querySelector('.skp-time');
    var seeking = false, hideTimer = null;

    function paint() {
      var d = v.duration, t = v.currentTime, r = (d && isFinite(d)) ? Math.min(1, t / d) : 0;
      fill.style.width = (r * 100) + '%';
      knob.style.left = (r * 100) + '%';
      track.setAttribute('aria-valuenow', Math.round(r * 100));
      time.textContent = (d && isFinite(d)) ? fmt(d - t) : fmt(t);
    }
    function syncPlay() {
      var playing = !v.paused && !v.ended;
      wrap.classList.toggle('is-playing', playing);
      bPlay.innerHTML = playing ? ICON.pause : ICON.play;
      bPlay.setAttribute('aria-label', playing ? 'Pause' : 'Play');
    }
    function syncMute() {
      bMute.innerHTML = v.muted ? ICON.muted : ICON.sound;
      bMute.setAttribute('aria-label', v.muted ? 'Turn sound on' : 'Turn sound off');
    }
    function syncFs() {
      var on = fsElement() === wrap;
      bFs.innerHTML = on ? ICON.fsExit : ICON.fs;
      bFs.setAttribute('aria-label', on ? 'Exit full screen' : 'Full screen');
    }
    function wake() {
      wrap.classList.add('is-active');
      clearTimeout(hideTimer);
      hideTimer = setTimeout(function () { if (!seeking) wrap.classList.remove('is-active'); }, 2200);
    }
    function togglePlay() {
      if (v.paused || v.ended) { delete wrap.dataset.skpUserPaused; play(v); }
      else { v.pause(); wrap.dataset.skpUserPaused = '1'; }
    }
    function setSound(on) {
      if (on) { muteOthers(v); v.muted = false; if (v.volume === 0) v.volume = 1; play(v); }
      else { v.muted = true; }
    }

    v.addEventListener('play', syncPlay);
    v.addEventListener('pause', syncPlay);
    v.addEventListener('ended', syncPlay);
    v.addEventListener('timeupdate', function () { if (!seeking) paint(); });
    v.addEventListener('loadedmetadata', paint);
    v.addEventListener('durationchange', paint);
    v.addEventListener('volumechange', syncMute);

    bPlay.addEventListener('click', function (e) { e.stopPropagation(); togglePlay(); wake(); });
    bMute.addEventListener('click', function (e) { e.stopPropagation(); setSound(v.muted); wake(); });
    bFs.addEventListener('click', function (e) {
      e.stopPropagation();
      if (fsElement() === wrap) {
        (document.exitFullscreen || document.webkitExitFullscreen).call(document);
        return;
      }
      ensureSrc(v);
      if (wrap.requestFullscreen) {
        wrap.requestFullscreen().then(function () { if (v.paused) play(v); }).catch(function () { iosFs(); });
      } else if (wrap.webkitRequestFullscreen) {
        wrap.webkitRequestFullscreen(); if (v.paused) play(v);
      } else {
        iosFs();
      }
    });
    function iosFs() {
      // iPhone: solo el <video> puede ir a pantalla completa (reproductor nativo, con su propia barra).
      if (v.webkitEnterFullscreen) {
        if (v.readyState < 1) { v.addEventListener('loadedmetadata', function h() { v.removeEventListener('loadedmetadata', h); v.webkitEnterFullscreen(); }); play(v); }
        else { v.webkitEnterFullscreen(); if (v.paused) play(v); }
      }
    }
    document.addEventListener('fullscreenchange', syncFs);
    document.addEventListener('webkitfullscreenchange', syncFs);

    function seekTo(clientX) {
      var r = track.getBoundingClientRect();
      var ratio = Math.max(0, Math.min(1, (clientX - r.left) / r.width));
      if (v.duration && isFinite(v.duration)) {
        v.currentTime = ratio * v.duration;
        fill.style.width = (ratio * 100) + '%';
        knob.style.left = (ratio * 100) + '%';
        time.textContent = fmt(v.duration - v.currentTime);
      } else {
        ensureSrc(v);
        v.addEventListener('loadedmetadata', function h() { v.removeEventListener('loadedmetadata', h); v.currentTime = ratio * v.duration; paint(); });
        v.load();
      }
    }
    track.addEventListener('pointerdown', function (e) {
      e.preventDefault(); e.stopPropagation();
      seeking = true; wrap.classList.add('is-seeking', 'is-active');
      try { track.setPointerCapture(e.pointerId); } catch (err) {}
      seekTo(e.clientX);
    });
    track.addEventListener('pointermove', function (e) { if (seeking) { e.preventDefault(); seekTo(e.clientX); } });
    function endSeek(e) {
      if (!seeking) return;
      seeking = false; wrap.classList.remove('is-seeking');
      try { track.releasePointerCapture(e.pointerId); } catch (err) {}
      wake();
    }
    track.addEventListener('pointerup', endSeek);
    track.addEventListener('pointercancel', endSeek);
    track.addEventListener('click', function (e) { e.stopPropagation(); });
    track.addEventListener('keydown', function (e) {
      if (!v.duration) return;
      if (e.key === 'ArrowRight') { v.currentTime = Math.min(v.duration, v.currentTime + 5); e.preventDefault(); }
      if (e.key === 'ArrowLeft') { v.currentTime = Math.max(0, v.currentTime - 5); e.preventDefault(); }
      paint(); wake();
    });
    bar.addEventListener('click', function (e) { e.stopPropagation(); });

    v.addEventListener('click', function (e) {
      e.preventDefault();
      if (v.muted && !v.paused) setSound(true);
      else togglePlay();
      wake();
    });
    wrap.addEventListener('pointermove', wake);

    syncPlay(); syncMute(); syncFs(); paint();
    if (observer) observer.observe(wrap);
    else if (wrap.hasAttribute('data-sk-autoplay')) play(v);
  }

  function init(root) {
    injectCss();
    (root || document).querySelectorAll('.skp').forEach(enhance);
  }

  window.SKPlayer = { init: init, enhance: enhance };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
